import { render, staticRenderFns } from "./TablaComponente.vue?vue&type=template&id=4fde73b6"
import script from "./TablaComponente.vue?vue&type=script&lang=js"
export * from "./TablaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports